/* eslint-disable max-lines-per-function */
import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Typography } from '@material-ui/core';
import MUITextField from '../../shared/components/MUITextField';
import { Button } from 'semantic-ui-react';
import { useUpdateAmenityTypes, useCreateAmenityTypes } from '../../api/amenity-types';


const styles = {
    formBoxBottom: {
        margin: '0px 0px',
        padding: '20px 0px',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    formButton: {
        width: '500px',
        height: '10px'
    }
};

// non si possono creare duplicati
// non ti fa cancellare un TYPE o un TAG se e' presente in uno degli ordini

const FormBox = props => <Box sx={{
    my: 1
}}>{ props.children }</Box>;

const FormTypes = props => {

    const { initialValues, amenity_tags_ordered } = props;

    const isNew = !initialValues.tag;
    const { mutate: createAmenityTypes } = useCreateAmenityTypes();
    const { mutate: updateAmenityTypes } = useUpdateAmenityTypes();

    const onSubmit = async values => {

        const payload = {
            tag: values.tag,
            type: values.type
        };

        if (isNew) {
            await createAmenityTypes(payload);
            props.setModalNamesOpen(false);

            return;
        }

        await updateAmenityTypes({
            payload: {
                old_tag_value: initialValues.tag,
                tag: values.tag,
                old_type_value: initialValues.type,
                type: values.type
            }
        });
        props.setModalNamesOpen(false);

    };

    const tag_menu = [];
    amenity_tags_ordered.map(x => {
        tag_menu.push({
            key: x.name,
            value: x.name,
            label: x.name
        });

        return tag_menu;
    });


    return (
        <FinalForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            render={({
                handleSubmit, submitting, pristine, values, form: { mutators }
            }) => (
                <form onSubmit={handleSubmit}>

                    <Grid item >
                        <Typography variant='h5' style={{ color: '#002144' }}>New Type</Typography>
                    </Grid>

                    <p></p>

                    <Box sx={{ width: '100%' }} style={{ marginTop: '20px' }}>
                        <FormBox>
                            <MUITextField
                                name='tag'
                                label='Tag Name'
                                defaultValue={initialValues?.tag || ''}
                                variant='outlined'
                                select
                                menu={tag_menu}
                                required
                            />
                        </FormBox>
                    </Box>
                    <Box sx={{ size: '100%' }} style={{ marginTop: '20px' }}>

                        <MUITextField
                            name='type'
                            label='Type Name'
                            required
                            variant='outlined'
                            defaultValue={initialValues?.type || ''}
                        />
                    </Box>

                    <div style={styles.formBoxBottom}>
                        <Button negative onClick={() => props.setModalNamesOpen(false)}>
                            Cancel
                        </Button>
                        <Button floated='right' positive disabled={submitting || pristine}>
                            Submit
                        </Button>

                    </div>
                </form>
            )}
        />
    );
};

export default FormTypes;
